import React, { useEffect, useState } from "react";
import { getAxiosResponse, getAxiosResponseAndSetState, putAxiosResponse, handleError } from "../../../services/authApiRoutes/APImethods";
import $ from "jquery";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import APIUrls from "../../../services/APIUrls";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import { ActiveMultiAssigneeIcon,ActiveAssigneeManIcon, GreenTickIcon, ContentTypeLogo, FilesValidatedLogo, SuccessTick, ReferenceMaterialsLogo, ActiveCannotRequestRevisionIcon, ActiveCanRequestRevisionIcon, CrossIconForModal, SkipIcon } from "../../../AppIcons";
import { projectPriority, translationModeCodes } from "../../../services/Util";
import Constants from "../../../Constants";
import { ConditionalBlock } from "../../../ConditionalBlock";
import DateFormat from "../../../pages/DateFormat";

export default function ProjectDetailTab(prop) {
  const projectData = prop.projectDetail;
  const projectResource = prop.projectDetail.resource?.projectResource;
  const projectStatus = prop.projectDetail.displayName[0].status;
  const param = useParams();
  const [followers, setFollowers] = useState([]);
  const [workflow, setworkflowData] = useState([]);
  const [typeOfModel, setTypeOfModel] = useState("");
  const [selectedTargetLang, setTargetLang] = useState("");
  const [targetLanguages, setTargetLanguageOptions] = useState([]);
  const [languageDetail, setLanguageDetail] = useState([]);
  const [sourceReferenceData, setSourceReferenceData] = useState([]);
  const [sourceAssets, setSourceAssets] = useState([]);
  const [translationMode, setTranslationMode] = useState();
  const [toggleexpanded, setToggleexpanded] = useState(false);
  const [skipPostEditing, setSkipPostEditing] = useState(false);
  const { t } = useTranslation();
  const translate = t;

  const custBootstrapDataRedux = useSelector((store) => store.customer_bootstrap_data).value;
  
  const getProjectFollowLinkState = () => {
    // possible states:
    // already a follower: "REMOVE_FOLLOWER"
    // not a follower: "ADD_FOLLOWER"
    // project owner: "NO_LINK"
    var contextId;
    if (custBootstrapDataRedux?.roleSet?.customerType) {
      contextId = custBootstrapDataRedux?.user?.userId;
      if (projectResource && projectResource.owner && projectResource.owner.userId === contextId) return "NO_LINK";
    } else return "NO_LINK";

    if (followers) {
      var inFollowers = false;
      var workflowAssignee = false;
      followers.forEach((follower) => {
        if (follower && follower.resource.userId === contextId) {
          if (follower.displayName[0].projectWorkflowAssignee === true) {
            workflowAssignee = true;
          }
          inFollowers = true;
        }
      });
      if (workflowAssignee) return "NO_LINK";
      if (inFollowers) return "REMOVE_FOLLOWER";
    }
    return "ADD_FOLLOWER";
  };

  const addFollower = () => {
    var payload = { id: param.id };
    putAxiosResponse(APIUrls.FOLLOW_UNFOLLOW_PROJECT(param.id), payload)
      .then((res) => {
        prop.refresh("projectDetail");
      })
      .catch((err) => {
        console.error(err);
      });
  };
 
  const phaseCompletedStatus = (currentStep, currentPhase) => {
    return languageDetail.steps.map((step,stepIndex)=>{
      return step.phases.map((phase,phaseIndex)=>{
       return isPhaseCompleted(phase,step.stepNumber,currentStep,currentPhase)
      })
    })
  };
  const isPhaseCompleted = (phase, stepNumber, currentStep, currentPhase) => {
    // this is based on this.currentStep and this.currentPhase
    if ( !currentStep || !currentPhase || !currentStep.stepNumber || !currentPhase.phaseNumber ) {
      return false;
    }
    if (currentStep.stepNumber > stepNumber) {
      // If the current step number is after this phase's step number, this phase is completed
      return true;
    } else if (currentStep.stepNumber < stepNumber) {
      // Conversely, if the current step number is after this phase's step number, this phase is incomplete
      return false;
    } else {
      // this means this step is the active step
      return phase.phaseNumber < currentPhase.phaseNumber;
    }
  };

  useEffect(() => {
    if (projectResource.projectContentType === "MARKETOREST") {
      getAxiosResponse(
        APIUrls.MARKETO_REST_PROJECT_TRANSLATION_MODE(param.id)
      ).then((res) => {
        setTranslationMode(res.data.data);
      });
    }
  }, [prop]);

  function hideModel() {
    document.body.classList.remove("modal-open");
    $(".add-focus").trigger("focus");
    $('.add-focus').removeClass('add-focus');
  }

	const hideModalOnKeyDown =(e)=>{
		if (e.key===Constants.ESCAPE){
			hideModel();
		}
	}

  function showModel(type,event) {
    $(event.target).addClass('add-focus')
    setTypeOfModel(type);
    document.body.classList.add("modal-open");
    setTimeout(() => {
      $("#close-popup").trigger("focus");
    }, 300);
  }

  const handleTargetLangSelect = (event) => {
    setSkipPostEditing(false);
    var selectedLang = event.value;
    setTargetLang(selectedLang);
    if (selectedLang !== "") {
      getAxiosResponse(APIUrls.LANGUAGE_STATUS(param.id, selectedLang))
        .then((res) => {
          if (res.data !== "") {                        
            let steps =  res.data.data.steps;            
            for(let stepIndex=0;stepIndex<steps.length;stepIndex++){              
              let phases = steps[stepIndex].phases;
              for(let phaseIndex=0;phaseIndex<phases.length;phaseIndex++){                
                let phase = phases[phaseIndex];
                if(phase.phaseType.originalEnum == "POST_EDITING"){                  
                    getAxiosResponse(`${APIUrls.ALL_TASKS}?phaseId=${phases[phaseIndex].id}&onlyFollowed=false`).then((res)=>{
                    let tasks = res.data.data.result;                        
                        let reviewProjectAssetSkippedTask = tasks.find((task)=>task.type.originalEnum == "REVIEW_PROJECT_ASSETS" && task.skipped);                      
                        if(reviewProjectAssetSkippedTask ){                            
                            setSkipPostEditing(true);
                        }                        
                    });
                }
              }
            }            
            setLanguageDetail(res.data.data);

          }
        })
        .catch((err) => {
          handleError(err);
        });
    } else {
      setTargetLang([]);
    }
  };

  const getWorkflowStatusForQuery = () => {
    if (projectStatus.cancelled || projectStatus.inCancellation) return "CANCELLED";
    if (!projectStatus.bidSelected) return "PENDING";
    if (projectStatus.closed) return "COMPLETED";
    return "OPEN,COMPLETED";
  };

  useEffect(() => {
    var targetLangs = [];
    if (prop.projectDetail.resource.projectResource.targetLanguages.length > 0) {
      prop.projectDetail.displayName[0].targetLanguages.map(
        (targetLang, index) => {
          targetLangs.push({
            label: targetLang.display,
            value: targetLang.code,
          });
        }
      );
    }

    setTargetLanguageOptions(targetLangs);
    getAxiosResponseAndSetState(APIUrls.ASSET_LIST(param.id), setSourceAssets);
    getAxiosResponse(APIUrls.REFERENCE_LIST(param.id))
      .then((res) => {
        if (res.data !== "") {
          setSourceReferenceData(res.data.data);
        }
      })
      .catch((err) => {
        handleError(err);
      });
    getAxiosResponse(APIUrls.PROJECT_FOLLOWERS_WITH_WORKFLOW_ASSIGNEE_INFO(param.id))
      .then((res) => {
        if (res.data !== "") {
          setFollowers(res.data.data);
        }
      })
      .catch((err) => {
        handleError(err);
      });
    getAxiosResponse(APIUrls.EXISTING_PROJECT_WORKFLOW(param.id, getWorkflowStatusForQuery()))
      .then((res) => {
        if (res.data !== "") {
          setworkflowData(res.data.data[0]);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  }, []);

  const traceFocus = (event) => {
    if (document.activeElement.id === "close-popup" && event.keyCode === Constants.TAB_KEYCODE && event.shiftKey === false) {
      event.preventDefault();
      $("#close-popup").trigger("focus");
    }
  };

  const toggleStepExpansion = (e) => {
    toggleexpanded ? setToggleexpanded(false) : setToggleexpanded(true);
     var step = e.target.closest(".workflow-step-list");
    if(step.classList.contains('open-step')) {
        step.classList.remove('open-step')
    } else {
        step.classList.add('open-step')
    }
    e.stopPropagation();
  }

  const displaySelectedVendors = () => {
    switch (projectResource?.projectVendorType) {
      case Constants.EXTERNAL:
      case Constants.EXTERNAL_BIDLESS:
        return (
          <>
            <ConditionalBlock condition={projectResource.vendor}>
              <Link to={`/vendors/${projectResource.vendor.id}`}>{projectResource.vendor.name}</Link>
            </ConditionalBlock>
            <ConditionalBlock condition={!projectResource.vendor}>
            <div className="translate-box-list">
              <a className='readonly' tabIndex="-1" aria-label="tab">
                <span>External Vendor</span>
              </a>
            </div>
            </ConditionalBlock>
          </>)
      case Constants.INTERNAL:
        return (
          <div className="translate-box-list">
            <a className='readonly' tabIndex="-1" aria-label="tab">
            <span>{`${projectResource?.internalTranslator?.firstName} ${projectResource?.internalTranslator?.lastName}`}</span>
            </a>
          </div>
        );
      case Constants.MACHINE_TRANSLATION:
        return (
          <div className="translate-box-list">
            <a className='readonly' tabIndex="-1" aria-label="tab">
              <span>{projectResource?.translationEngineType?.display}</span>
            </a>
          </div>
        );
      default:
        return;
    }
  }

  return (
    <>
      <div className="listing-content">
        <div className="project-information">
          <h6>Project Information</h6>
          <div className="project-table">
            <ul>
              <li>
                <div className="title">Project Name</div>
                <div className="text">{projectResource.name}</div>
              </li>
              <li>
                <div className="title">Campaign</div>
                <div className="text">{projectResource.workspace !== "" ? projectResource.workspace.name : Constants.NOT_APPLICABLE}</div>
              </li>
              <li>
                <div className="title">Translation Start Date</div>
                {projectResource.translationStartDate !== "" ? (
                  <div className="text">{projectResource?.translationStartDate?.dateWithTime}</div>
                ) : (Constants.NOT_APPLICABLE)}
              </li>
            </ul>
            <ul>
              <li>
                <div className="title">Department</div>
                <div className="text">{projectResource.userGroup?.name}</div>
              </li>
              <li>
                <div className="title">Intended Use</div>
                <div className="text">{projectResource.intendedUse.name}</div>
              </li>
              <li>
                <div className="title">First Translation Deadline</div>
                {projectResource.deliveryDueDate !== "" ? (
                  <div className="text">{projectResource?.deliveryDueDate?.dateWithTime}</div>
                ) : (Constants.NOT_APPLICABLE)}
              </li>
            </ul>
            <ul>
              <li>
                <div className="title">Total Words</div>
                <div className="text">
                  {projectResource.wordCountString !== "" ? projectResource.wordCountString + " words" : Constants.NOT_APPLICABLE}
                </div>
              </li>
              <li>
                <div className="title">Priority</div>
                <div className="text">{projectPriority[projectResource.priority]}</div>
              </li>
              <li>
                <div className="title">Created On</div>
                {projectResource.createdDate !== "" ? (
                  <div className="text">{projectResource?.createdDate.dateWithTime}</div>
                ) : (Constants.NOT_APPLICABLE)}
              </li>
            </ul>
            <ul>
              <li>
                <div className="title">Project Owner</div>
                <div className="text">{projectResource.owner.firstName + " " + projectResource.owner.lastName}
                </div>
              </li>
              <li>
                <div className="title">Content Source</div>
                <div className="text">{projectResource.projectContentTypeDisplay}</div>
              </li>

              <li>
                <div className="title">Translation Mode</div>
                <div className="text">{projectResource.projectContentType === "MARKETOREST" ? translationModeCodes[translationMode] : Constants.NOT_APPLICABLE}
                </div>
              </li>
            </ul>
            <ul>
              <li>
                <div className="title">Vendor Billing Status</div>
                <div className="text">{custBootstrapDataRedux?.permissions?.PROJECT_CUD && prop.projectDetail.displayName[0]?.vendorBillingStatus !== undefined
                    ? custBootstrapDataRedux.roleSet.customerType ? prop.projectDetail.displayName[0]?.vendorBillingStatus?.customerDisplay : prop.projectDetail.displayName[0]?.vendorBillingStatus?.vendorDisplay
                    : Constants.NOT_APPLICABLE}
                </div>
              </li>{prop?.projectDetail?.resource?.projectResource?.projectRequest?
                <li><div className="title">Project Request</div>
                <div className="text">
                  {prop?.projectDetail?.resource?.projectResource?.projectRequestEditable?
                  <Link to={`/project-request/show/${prop?.projectDetail?.resource?.projectResource?.projectRequest?.id}`}>{prop?.projectDetail?.resource?.projectResource?.projectRequest?.name}</Link>:<span>{prop?.projectDetail?.resource?.projectResource?.projectRequest?.name}</span>}
                </div></li>:<li>{Constants.BLANK}</li>}
              
              {projectResource.projectUpdateGlossary !== "" ? (
                <React.Fragment>
                  <li>
                    <div className="title">Glossary to Update</div>
                    <div className="text">{projectResource.projectUpdateGlossary.generalGlossary ? "Glossary" : projectResource.userGroup.name + " Glossary"}</div>
                  </li>
                  <li>
                    <div className="title">Glossary Term Status On Completion</div>
                    <div className="text">{projectResource.projectUpdateGlossary.termStatusOnCompletion.display}</div>
                  </li>
                </React.Fragment>
              ) : (<React.Fragment><li></li></React.Fragment>)}
            </ul>
            <ul>
              <li>
                <div className="title">Project ID</div>
                <div className="text">{prop.projectDetail?.resource?.projectResource?.id}</div>
              </li>
              <li>
                <div className="title">Source Language</div>
                <div className="text">{prop.projectDetail?.displayName[0]?.sourceLanguage?.display}</div>
              </li>
              <li>
                <div className="title">Customer Billing Status</div>
                <div className="text">
                  {prop.projectDetail?.displayName?.[0]?.customerBillingStatus 
                    ? `${prop.projectDetail.displayName[0].customerBillingStatus.display}${prop.projectDetail.resource?.projectResource?.customerPaidDate?.date ? ` (${prop.projectDetail.resource.projectResource.customerPaidDate.date})` : Constants.BLANK}`
                    : Constants.NOT_APPLICABLE}
                </div>
              </li>
            </ul>
            <ul>
              <li>
                <div className="title">Amount</div>
                <div className="text">{prop.projectDetail?.displayName[0]?.amount.displayWithDecimals}
                </div>
              </li>
              <li>
                <div className="title">Tags</div>
                <div className="text">
                  {projectResource.tags.length !== 0 ? (
                    projectResource.tags.map((tag, index) => {
                      return (<button className="progress readonly" key={index} tabIndex="-1">{tag}</button>);
                    })
                  ) : (<p>No Tags Selected</p>)}
                </div>
              </li>
              <li>
                <div className="title">Target Language</div>
                <div className="text">
                  {projectResource.targetLanguages.length !== 0 ? (
                    prop.projectDetail.displayName[0].targetLanguages.map(
                      (langs, index) => {
                        if (projectResource.targetLanguages.length > 2) {
                          if (index + 1 < 3) {
                            return (
                              <React.Fragment key={index}>{langs.display + ", "}</React.Fragment>
                            );
                          } else {
                            if (projectResource.targetLanguages.length === index + 1) {
                              return (
                                <button onClick={(e) => showModel("languages",e)} key={index} id='target-id' aria-label={`+ ${(projectResource.targetLanguages.length - 2)} more target language`}>
                                  {" "}+{projectResource.targetLanguages.length - 2}
                                </button>
                              );
                            } else return "";
                          }
                        } else {
                          if (projectResource.targetLanguages.length > index + 1) return langs.display + ", ";
                          else return langs.display;
                        }
                      }
                    )
                  ) : (<p>No target language selected</p>)}
                </div>
              </li>
            </ul>
            <ul>
              <li>
                <div className="title">Project description</div>
                <div className="text">{projectResource.description !== "" ? projectResource.description : Constants.NOT_APPLICABLE}</div>
              </li>
              <ConditionalBlock condition={projectResource.skipTmUpload}>
                <li>
                  <div className="title">Translation Memory Upload</div>
                  <div className="text">This project will skip the Translation Memory Upload step</div>
                </li>
              </ConditionalBlock>
              <li>{Constants.BLANK}</li>
            </ul>
          </div>
        </div>
        <h5>Content Type</h5>
        <ul className="summary-Content-type flex">
          <li>
            <div className="flex-center flex">
              {ContentTypeLogo}
              <span>{projectResource.projectContentTypeDisplay}</span>
            </div>
          </li>
        </ul>
        <h6>Files / Assets Validated</h6>
        <div className="files-validate flex">
          {sourceAssets.map((sourceAsset, index) => {
            return (
              <div className="uploading-file-list flex html-format width-m" key={index}>
                <div className="left-file-desc flex-center w-d100">
                  <div className="icon-block">{FilesValidatedLogo}</div>
                  <div className="file-text">
                    <span className="ext-name">
                      <small>{sourceAsset.filename}</small>
                      {SuccessTick}
                    </span>
                    <strong>
                      <span className="date-name">
                        <DateFormat date={sourceAsset.createdDate}/>
                      </span>
                      <span className="file-size">{sourceAsset.sizeInKilobytes / 1000} mb</span>
                    </strong>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {sourceReferenceData.length !== 0 ? (
          <>
            <h6>Reference Material</h6>
            <div className="files-validate flex">
              {sourceReferenceData.map((reference, index) => {
                return (
                  <div className="uploading-file-list flex html-format width-m" key={index}>
                    <div className="left-file-desc flex-center w-d100">
                      <div className="icon-block">{ReferenceMaterialsLogo}</div>
                      <div className="file-text">
                        <span className="ext-name">
                          <small>{reference.filename}</small>
                          {SuccessTick}
                        </span>
                        <strong>
                          <span className="date-name">
                            <DateFormat date={reference.createdDate}/>
                          </span>
                          <span className="file-size">{reference.sizeInKilobytes / 1000} mb</span>
                        </strong>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        ) : null}
        <h6>Translation Summary</h6>
        <div className="translation-summary">
          <ul className="summary-inline-list">
          <li>
                <strong className="pt-30">Vendor</strong>
                <div className="translate-box flex width-auto">
                  {displaySelectedVendors()}
                </div>
              </li>
          </ul>
          <h6>Deadline for Vendors</h6>
          <ul className="summary-inline-list">
            {projectResource?.projectVendorType === "EXTERNAL" && (
              <>
              <li>
                <strong>Vendors must submit quotes by </strong>
                <div>
                  <span>{projectData.resource.projectResource.bidDueDate.dateWithTime}</span>
                </div>
              </li>
              <li>
              <strong> {translate("user_alert.label_project_bid_selection_deadline")} </strong>
              <div>
                <span>{projectData?.resource?.projectResource?.bidSelectDeadlineDate?.dateWithTime}</span>
              </div>
            </li></>
            )}
            <li>
              <strong>I need initial translation by</strong>
              <div>
                <span>{projectData?.resource?.projectResource?.deliveryDueDate?.dateWithTime}</span>
              </div>
            </li>
            <li>
              <strong>Project Currency</strong>
              <div>
                <span>{projectData?.displayName[0]?.currency?.pluralLabel}</span>
              </div>
            </li>
            <li>
              <strong>Purchase Order Number</strong>
              <div>
                <span>{projectData.resource.projectResource.purchaseOrder !== "" ? projectData.resource.projectResource.purchaseOrder.shortDisplay : Constants.NOT_APPLICABLE}</span>
              </div>
            </li>
            <li>
              <strong>Notes and Instructions for Vendors</strong>
              <div>
                <span>{projectData.resource.projectResource.notes !== "" ? projectData.resource.projectResource.notes : Constants.NOT_APPLICABLE}</span>
              </div>
            </li>
          </ul>
        </div>

        <h6>Workflow Details</h6>
        <div className="project-info-summary flex select-workflow project-tab-workflow">
          <ul className="full-width w-d100">
            <li>
              <strong>Name</strong>
              <div>
                <span>{workflow?.resource?.templateName}</span>
              </div>
            </li>
            <li>
              <strong>Description</strong>
              <div>
                <span>{workflow?.resource?.templateDescription}</span>
              </div>
            </li>
            <li style={{ marginTop: "30px" }}>
              <strong>Dates & Assignees</strong>
              <div>
                <div className="global-dropdown-block flex-center">
                  <Select classNamePrefix="cw" className="global-dropdown-select"
                    value={targetLanguages.filter(function (option) {
                      return option.value === selectedTargetLang;
                    })}
                    placeholder={'Select Languages'} aria-label="Languages" options={targetLanguages} onChange={(e) => handleTargetLangSelect(e)}/>
                </div>
              </div>
            </li>
          </ul>
          {languageDetail.length !== 0 ? (
            <div className="workflow-wrap clearfix">
              {languageDetail.steps.map((step, stepIndex) => {
                return (
                  <div className="workflow-step-list open-step" key={stepIndex}>
                    <div className="inner-step-list" >
                      <button className="step-btn" onClick={(e) => {toggleStepExpansion(e)}} aria-expanded={toggleexpanded ? 'false':'true'}>
                        <i className="plus-icon" onClick={(e) => {toggleStepExpansion(e)}}></i>
                        {step.name}
                      </button>
                        <div className="workflow-step-content flex">
                        {step.phases.map((phase, phaseIndex) => {
                          return (
                            <div className="step-box-list" key={phaseIndex}>
                              <span className="step-cal flex-center readonly " aria-label="calender">                                
                                <ConditionalBlock condition={phase.phaseType.originalEnum === "POST_EDITING" && skipPostEditing}>
                                  <span className="align-center w-d100">
                                      {SkipIcon}
                                  </span>
                                </ConditionalBlock>    
                                <ConditionalBlock condition={!(phase.phaseType.originalEnum === "POST_EDITING" && skipPostEditing)}>
                                  {(phaseCompletedStatus(step, phase) || languageDetail.status === "COMPLETED") && phase.closedDate !== "" ? GreenTickIcon : "" }
                                  <span>{phase.closedDate !== "" ? phase.closedDate.date : phase.dueDate !== "" ? "Due " + phase.dueDate.dateWithTime : ""}</span>
                                </ConditionalBlock>    
                              </span>
                              {phase.name !== "" ? (<strong>{phase.name}</strong>) :
                              stepIndex === languageDetail.steps.length - 1 && phaseIndex === step.phases.length - 1 ? (
                                <strong>Final Review</strong>
                              ) : languageDetail.currentPhaseId === phase.id ? (
                                <strong>In {phase.phaseType.display}</strong>
                              ) : phase.phaseType.display !== "" ? (
                                phase.phaseType.code === "review" && step.phases.length > 2 ? (
                                  <strong>{phase.phaseType.display} {phaseIndex}</strong>
                                ) : (
                                  <strong>{phase.phaseType.display}</strong>
                                )
                              ) : (
                                <strong>{phase.phaseType.display}</strong>
                              )}
                              {phase.assignedToVendor && phase.assigneeType.code === "vendor" ? (
                                <strong>{phase.assigneeVendor !== '' ? phase.assigneeVendor.name : phase.assigneeType.display}</strong>
                              ) : phase.assigneeType.code === "customer_user" ? 
                                phase.allowMultiAssignee ?
                                <strong >{phase.assigneeUsers.length > 1 ? phase.assigneeUsers.length+' Reviewers' : phase.assigneeUsers.length+' Reviewer' } </strong>
                                :
                                phase.assigneeUsers.map((user, index) => {
                                  return (<strong key={index}>{user.fullName}</strong>);
                                })
                               : (
                                <strong></strong>
                              )}
                              <div className="step-assignee justify-center flex-center" aria-label="Single Assignee">
                                <div className="flex-center width-140">
                                  {phase.allowMultiAssignee ? 
                                  <>
                                  <span>Multiple Assignees</span>
                                  {ActiveMultiAssigneeIcon}
                                  </>  
                                  :
                                  <>
                                      {phase.assigneeType.code === "machine_translator" ? (<strong>{projectResource.translationEngineType.display}</strong>) : <strong></strong>}
                                      {phase.assigneeType.code != "machine_translator" && phase.assigneeType.code != "vendor" ? ActiveAssigneeManIcon : ""}
                                    </>  
                                }
                                </div>
                              </div>
                              {phase.isApprovalPhase ? <strong>Approval</strong> : ""}
                              <div className="step-request">
                                {!phase.allowRevision && (
                                  <div>
                                    <div className="left-icon">{ActiveCannotRequestRevisionIcon}</div>
                                    <span className={phase.allowRevision ? "revision-allowed" : "revision-disallowed"}>
                                      {phase.allowRevision ? "Can Request Revision" : "Cannot Request Revision"}
                                    </span>
                                  </div>
                                )}
                                {phase.allowRevision && (
                                  <div>
                                    <span className={phase.allowRevision ? "revision-allowed pl-0" : "revision-disallowed pl-0"}>
                                      {phase.allowRevision ? "Can Request Revision" : "Cannot Request Revision "}
                                    </span>
                                    <div className="left-icon">{ActiveCanRequestRevisionIcon}</div>
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>                    
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="project-follower">
          <h6>Project followers </h6>
          <p>
            {followers.map((follower, index) => {
              if (followers.length > 4) {
                if (index + 1 < 5) {
                  return (
                    <React.Fragment key={index}>
                      {`${follower.resource.firstName} ${follower.resource.lastName}`}
                      {follower.displayName[0].roles.length !== 0 ? 
                      <span>{" "}
                        (
                        {follower.displayName[0].roles?.map((role) => {
                          return role;
                        })}
                        )
                      </span> : ''
                      } 
                      {index !== 3 ? ", " : " "}
                    </React.Fragment>
                  );
                } else {
                  if (followers.length === index + 1) {
                    return (
                      <button className="follower-link" aria-label={`+ ${(followers.length - 4)} Followers`} onClick={(e) => showModel("follower", e)} id="follower-link-id">
                        + {followers.length - 4} Followers
                      </button>
                    );
                  }
                }
              } else {
                if (followers.length > index + 1) {
                  return (
                    <React.Fragment key={index}>
                      {`${follower.resource.firstName} ${follower.resource.lastName}`}
                      <span>
                        (
                        {follower.displayName[0].roles?.map((role) => {
                          return role;
                        })}
                        )
                      </span>
                      {", "}
                    </React.Fragment>
                  );
                } else {
                  return (
                    <React.Fragment key={index}>
                      {`${follower.resource.firstName} ${follower.resource.lastName}`}
                      <span>
                        ({follower.displayName[0].roles?.map((role) => {
                          return role;
                        })})
                      </span>{" "}
                    </React.Fragment>
                  );
                }
              }
            })}
            <span style={{ marginLeft: "30px" }}>
              {getProjectFollowLinkState() === "ADD_FOLLOWER" ? (
                <Link onClick={addFollower}>Follow Project</Link>
              ) : getProjectFollowLinkState() === "REMOVE_FOLLOWER" ? (
                <Link onClick={addFollower}>Stop Following Project</Link>
              ) : getProjectFollowLinkState() === "NO_LINK" ? (
                ""
              ) : (
                ""
              )}
            </span>
          </p>
        </div>
      </div>
      <div id="modelPopup" className="lightbox-panel follower-list"  aria-labelledby="language-popup" aria-modal="true" role="dialog" onKeyDown={(e)=>hideModalOnKeyDown(e)}>
        <div className="inner-lightbox-panel" onKeyDown={(e) => traceFocus(e)}>
          <div className="modal-header flex" >
            <div id='language-popup'>
            {typeOfModel === "follower" ? (<strong>List of Followers</strong>) : (<strong>List of Languages</strong>)}
            </div>
            <button className="close" aria-label="close" onClick={hideModel} id='close-popup'>
              {CrossIconForModal}
            </button>
          </div>
          <div className="lightbox-content">
            {typeOfModel === "follower" ? (
              <ul className="follower-list-item">
                {followers.map((follower, index) => {
                  return (
                    <li key={index}>
                      <p>
                        {`${follower.resource.firstName} ${follower.resource.lastName}`}{" "}
                        (
                        {follower.displayName[0].roles.map((role, index) => {
                          return (
                            <React.Fragment key={index}>{role}</React.Fragment>
                          );
                        })}
                        )
                      </p>
                    </li>
                  );
                })}
              </ul>
            ) : (
              <ul className="follower-list-item">
                {projectResource.targetLanguages.length !== 0
                  ? prop.projectDetail.displayName[0].targetLanguages.map(
                      (langs, index) => {
                        return (
                          <li key={index}>
                            <p>{langs.display}</p>
                          </li>
                        );
                      }
                    )
                  : "No target language selected"}
              </ul>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
